const Loader2 = () => {
  return (
    <>
      <div className="spinner"></div>
      <style jsx>{`
        .spinner {
          border: 5px solid #f3f3f3;
          border-top: 5px solid #3498db;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          margin-top: -25px;
          position: absolute;
          top: 29px;
          left: 6px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default Loader2;
